<div class="modal-header">
  <h5 class="modal-title mt-0">Add Customer</h5>
  <button type="button" class="btn-close" aria-hidden="true"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row g-3">
      <div class="col-md-12">
        <label class="form-label">Customer Name</label>
        <input type="text" class="form-control" formControlName="name"
          [ngClass]="{'is-invalid': submitted && formData.get('name')?.errors}">
        <div *ngIf="submitted && formData.get('name')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('name')?.errors?.required">Customer name is required.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">GST No</label>
        <input type="text" class="form-control" formControlName="gstNo"
          [ngClass]="{'is-invalid': submitted && formData.get('gstNo')?.errors}">
        <div *ngIf="submitted && formData.get('gstNo')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('gstNo')?.errors?.pattern">GST no format is invalid.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">PAN No</label>
        <input type="text" class="form-control" formControlName="panNo"
          [ngClass]="{'is-invalid': submitted && formData.get('panNo')?.errors}">
        <div *ngIf="submitted && formData.get('panNo')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('panNo')?.errors?.pattern">PAN no format is invalid.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">TAN No</label>
        <input type="text" class="form-control" formControlName="tanNo"
          [ngClass]="{'is-invalid': submitted && formData.get('tanNo')?.errors}">
        <div *ngIf="submitted && formData.get('tanNo')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('tanNo')?.errors?.pattern">TAN no format is invalid.</span>
        </div>
      </div>
    </div>

    <div class="modal-footer px-0 pb-0 mt-3">
      <button type="button" class="btn btn-outline-secondary"
        (click)="activeModal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-success" [disabled]="isSaving">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Save
      </button>
    </div>
  </form>
</div>
